export default __webpack_public_path__ + "static/media/bkwp-picturemark-d.bf130995.svg";